/**
 * Created by david.vanoni@coplex.com on 9/7/17.
 */

import { denormalize } from 'normalizr';
import { surveyResponse as surveyResponseSchema } from '../lib/schema.js';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';

// API Actions
const RETRIEVE_SURVEY_RESPONSE_REQUEST =
  'changesync/surveyResponses/RETRIEVE_SURVEY_RESPONSE_REQUEST';
const RETRIEVE_SURVEY_RESPONSE_SUCCESS =
  'changesync/surveyResponses/RETRIEVE_SURVEY_RESPONSE_SUCCESS';
const RETRIEVE_SURVEY_RESPONSE_FAILURE =
  'changesync/surveyResponses/RETRIEVE_SURVEY_RESPONSE_FAILURE';

// Action Creators

export const retrieveSurveyResponse = (id) => ({
  [CALL_API]: {
    types: [
      RETRIEVE_SURVEY_RESPONSE_REQUEST,
      RETRIEVE_SURVEY_RESPONSE_SUCCESS,
      RETRIEVE_SURVEY_RESPONSE_FAILURE,
    ],
    endpoint: `survey_responses/${id}`,
    method: HTTP_METHODS.GET,
    schema: surveyResponseSchema,
  },
});

// Selectors

export const selectSurveyResponse = (id) => (state) => {
  const surveyResponse = denormalize(id, surveyResponseSchema, state.entities);
  return (
    surveyResponse && {
      ...surveyResponse,
      startDate: new Date(surveyResponse.startDate),
      endDate: new Date(surveyResponse.endDate),
    }
  );
};
